/**
 * Mutation to remove a typology from a seller
 */
const removeTypologyFromSellerMutation = `
mutation RemoveTypologyFromSeller($sellerId: ID!, $typologyId: ID!) {
  updateMarketplace_seller(
    input: {
      id: $sellerId
      fields: {
        typologies: {
          remove: [$typologyId]
        }
      }
    }
  ) {
    marketplace_seller {
      objectId
      typologies {
        edges {
          node {
            objectId
            name
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default removeTypologyFromSellerMutation;
